import { c as _c } from "react/compiler-runtime";
import "@/styles/globals.css";
import "@/styles/tailwind.css";
import type { AppProps } from "next/app";
import { RouteUrlCleanup } from "@/components/RouteUrlCleanup";
export default function App(t0) {
  const $ = _c(4);
  const {
    Component,
    pageProps
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <RouteUrlCleanup />;
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] !== Component || $[2] !== pageProps) {
    t2 = <>{t1}<Component {...pageProps} /></>;
    $[1] = Component;
    $[2] = pageProps;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  return t2;
}